<template>
  <section class="row">
    <div class="col-12">
      <component
        :is="`v-${setting.type.toLowerCase()}`"
        v-for="(setting, index) in extension.settings"
        :key="setting.id"
        v-bind="getPropsFromSetting(setting)"
        class="my-2"
        :input-validation="(value) => (value ? null : false)"
        @validation="validation[index] = $event"
      />
    </div>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';
import Input from '@/components/common/input/Input2.vue';
import CustomSelect2 from '@/components/common/input/CustomSelect2.vue';
import CustomMultiSelect from '@/components/common/input/CustomMultiSelect.vue';

import { formatPrice } from '@/utils/_Number';

export default {
  name: 'DynamicExtension',
  components: {
    'v-number': Input,
    'v-choice': CustomSelect2,
    'v-list_stepper': CustomSelect2,
    'v-choice_multiple': CustomMultiSelect,
  },
  mixins: [ui],
  props: {
    extension: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['validation'],
  data() {
    return {
      validation: [],
    };
  },
  computed: {
    ...mapGetters({
      contract: 'contract/get',
    }),
    extensionId() {
      return this.extension.id;
    },
    extensionIndex() {
      return this.contract
        .extensions
        .findIndex(({ id }) => this.extensionId === id);
    },
    getPrice() {
      return this.contract.extensions[this.extensionIndex]
        .monthlyPremium;
    },
  },
  watch: {
    validation: {
      handler() {
        const allValid = this.validation.every((item) => item === true || item === null);
        this.$emit('validation', allValid);
      },
      deep: true,
    },
  },
  onMounted() {
    this.validation = this.extension.settings.map(() => null);
  },
  methods: {
    formatPrice,
    close() {
      this.ui_showModal(false);
    },
    next() {
      this.ui_showModal(false);
      return Promise.resolve();
    },
    getPropsFromNumberSetting(setting) {
      const { id } = setting;
      const { extensionIndex } = this;

      const settingIndex = this.extension
        .settings
        .findIndex(({ id: settingId }) => settingId === id);
      function getterFunction() {
        return setting.value;
      }
      const path = `extensions[${extensionIndex}].settings[${settingIndex}].value`;
      let inputValidation = (value) => (value ? null : false);
      if (setting.rules) {
        inputValidation = (value) => {
          const { min, max, message } = setting.rules;
          if (value < min) {
            this.errorMessage = 'La valeur doit être supérieure à 0';
            return false;
          }
          if (value > max) {
            this.errorMessage = message ?? `La valeur doit être inférieure à ${max}`;
            return false;
          }
          return null;
        };
      }
      return {
        errorMessage: this.errorMessage,
        mask: 'number',
        placeholder: '0',
        path,
        getterPath: path,
        inputValidation,
        getterFunction,
        setterFunction: (value) => ({ value, path }),
      };
    },
    getPropsForChoiceSetting(setting) {
      const { id } = setting;
      const { extensionIndex } = this;
      const settingIndex = this.extension
      .settings
      .findIndex(({ id: settingId }) => settingId === id);

      function getterFunction() {
        return setting.choices.find(({ enabled }) => enabled);
      }
      const path = `extensions[${extensionIndex}].settings[${settingIndex}].choices`;
      function setterFunction(value) {
        const choices = setting
          .choices
          .map((elem) => Object.assign(elem, { enabled: elem.id === value.id }));
        return { value: choices, path };
      }
      return {
        path,
        getterPath: path,
        list: setting.choices,
        getterFunction,
        setterFunction,
      };
    },
    getChoiceMultipleProps(setting) {
      const { extensionIndex } = this;
      const { id } = setting;
      const settingIndex = this.extension
        .settings
        .findIndex(({ id: settingId }) => settingId === id);

      const path = `extensions[${extensionIndex}].settings[${settingIndex}].choices`;

      function getterFunction() {
        return setting.choices.filter(({ enabled }) => enabled);
      }

      function setterFunction(value) {
        return { value, path };
      }
      return {
        list: setting.choices,
        path,
        getterPath: path,
        isSelectedFunction: (item) => item.enabled,
        inputValidation: (value) => (value ? null : false),
        setterFunction,
        getterFunction,
      };
    },
    getPropsFromSetting(setting) {
      const { label, id } = setting;
      const otherSetting = {};

      switch (setting.type) {
        case 'CHOICE':
          Object.assign(otherSetting, this.getPropsForChoiceSetting(setting));
          break;
        case 'LIST_STEPPER':
          Object.assign(otherSetting, this.getPropsForChoiceSetting(setting));
          break;
        case 'CHOICE_MULTIPLE':
          Object.assign(otherSetting, this.getChoiceMultipleProps(setting));
          break;
        case 'NUMBER':
          Object.assign(otherSetting, this.getPropsFromNumberSetting(setting));
          break;
        default:
          break;
      }

      return {
        inputId: `extension-setting-${id}`,
        label,
        moduleName: 'contract',
        getterName: 'get',
        setterName: 'updateSubscription',
        forceValidation: true,
        disabled: this.disabled,
        inputDisabled: this.disabled,
        ...otherSetting,
      };
    },
  },
};
</script>
